var React = require('react');

function TimeToRise (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.16663 1.5L1.66663 4M18.3333 4L15.8333 1.5M4.99996 14.8333L3.33329 16.5M15 14.8333L16.6666 16.5M9.99996 6.5V9.83333L11.6666 11.5M9.99996 16.5C11.7681 16.5 13.4638 15.7976 14.714 14.5474C15.9642 13.2971 16.6666 11.6014 16.6666 9.83333C16.6666 8.06522 15.9642 6.36953 14.714 5.11929C13.4638 3.86905 11.7681 3.16667 9.99996 3.16667C8.23185 3.16667 6.53616 3.86905 5.28591 5.11929C4.03567 6.36953 3.33329 8.06522 3.33329 9.83333C3.33329 11.6014 4.03567 13.2971 5.28591 14.5474C6.53616 15.7976 8.23185 16.5 9.99996 16.5Z","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

TimeToRise.defaultProps = {"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none"};

module.exports = TimeToRise;

TimeToRise.default = TimeToRise;
